import React from 'react';
import SelectTalent from './SelectTalent';
import SelectGender from './SelectGender';
import SelectYear from './SelectYear';
import SelectMonth from './SelectMonth';
import SelectCountries from './SelectCountries';
import SelectCities from './SelectCities';
import SelectSize from './SelectSize';
import SelectVerified from './select/SelectVerified';
import './UsersFilterWidget.css';

/**
 * CMS Users list filters (GET form). Multi-row layout, higher-contrast controls.
 */
export default function UsersFilterWidget({
    visible,
    filter_first_name,
    filter_last_name,
    filter_email,
    filter_gender_value,
    filter_talent_value,
    filter_course_value,
    filter_from_year_value,
    filter_from_month_value,
    filter_to_year_value,
    filter_to_month_value,
    filter_birth_country_value,
    filter_birth_city_value,
    filter_living_country_value,
    filter_living_city_value,
    filter_size_value,
    filter_is_verified_value,
    onValue,
}) {
    if (!visible) {
        return null;
    }

    return (
        <div className="users-filter-widget">
            <form action="" method="get" className="users-filter-widget__form">
                <div className="users-filter-widget__body">
                    <div className="users-filter-widget__row users-filter-widget__row--1">
                        <div className="users-filter-widget__cell users-filter-widget__cell--name">
                            <input
                                id="uf-first-name"
                                type="text"
                                name="first_name"
                                defaultValue={filter_first_name || ''}
                                className="form-control"
                                placeholder="First name"
                            />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--name">
                            <input
                                id="uf-last-name"
                                type="text"
                                name="last_name"
                                defaultValue={filter_last_name || ''}
                                className="form-control"
                                placeholder="Last name"
                            />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--name users-filter-widget__cell--email">
                            <input
                                id="uf-email"
                                type="text"
                                name="email"
                                defaultValue={filter_email || ''}
                                className="form-control"
                                placeholder="Email"
                                autoComplete="off"
                            />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--gender">
                            <SelectGender
                                value={filter_gender_value}
                                width="100%"
                                border="1"
                                callback={onValue}
                                usersFilter
                                placeholder="Gender"
                            />
                            <input type="hidden" name="gender" value={filter_gender_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--talent">
                            <SelectTalent
                                value={filter_talent_value}
                                width="100%"
                                border="1"
                                callback={onValue}
                                usersFilter
                                placeholder="Talent"
                            />
                            <input type="hidden" name="talent" value={filter_talent_value ?? ''} />
                        </div>
                    </div>

                    <div className="users-filter-widget__row users-filter-widget__row--dob">
                        <div className="users-filter-widget__cell users-filter-widget__cell--dob">
                            <div className="users-filter-widget__inline-pair">
                                <div className="users-filter-widget__inline-item">
                                    <SelectYear
                                        value={filter_from_year_value}
                                        name="from_year"
                                        width="100%"
                                        callback={onValue}
                                        usersFilter
                                        placeholder="From year"
                                    />
                                    <input type="hidden" name="from_year" value={filter_from_year_value ?? ''} />
                                </div>
                                <div className="users-filter-widget__inline-item">
                                    <SelectMonth
                                        value={filter_from_month_value}
                                        name="from_month"
                                        width="100%"
                                        callback={onValue}
                                        usersFilter
                                        placeholder="From month"
                                    />
                                    <input type="hidden" name="from_month" value={filter_from_month_value ?? ''} />
                                </div>
                            </div>
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--dob">
                            <div className="users-filter-widget__inline-pair">
                                <div className="users-filter-widget__inline-item">
                                    <SelectYear
                                        value={filter_to_year_value}
                                        name="to_year"
                                        width="100%"
                                        callback={onValue}
                                        usersFilter
                                        placeholder="To year"
                                    />
                                    <input type="hidden" name="to_year" value={filter_to_year_value ?? ''} />
                                </div>
                                <div className="users-filter-widget__inline-item">
                                    <SelectMonth
                                        value={filter_to_month_value}
                                        name="to_month"
                                        width="100%"
                                        callback={onValue}
                                        usersFilter
                                        placeholder="To month"
                                    />
                                    <input type="hidden" name="to_month" value={filter_to_month_value ?? ''} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="users-filter-widget__row users-filter-widget__row--2">
                        <div className="users-filter-widget__cell users-filter-widget__cell--place">
                            <SelectCountries
                                kurds={1}
                                value={filter_birth_country_value}
                                name="country"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Born country"
                            />
                            <input type="hidden" name="country" value={filter_birth_country_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--place">
                            <SelectCities
                                country={filter_birth_country_value}
                                key={filter_birth_country_value}
                                value={filter_birth_city_value}
                                name="city"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Born city"
                            />
                            <input type="hidden" name="city" value={filter_birth_city_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--place">
                            <SelectCountries
                                value={filter_living_country_value}
                                name="living_country"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Living country"
                            />
                            <input
                                type="hidden"
                                name="living_country"
                                value={filter_living_country_value ?? ''}
                            />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--place">
                            <SelectCities
                                country={filter_living_country_value}
                                key={filter_living_country_value}
                                value={filter_living_city_value}
                                name="living_city"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Living city"
                            />
                            <input type="hidden" name="living_city" value={filter_living_city_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--small">
                            <SelectSize
                                value={filter_size_value}
                                name="size"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Page size"
                            />
                            <input type="hidden" name="size" value={filter_size_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--small">
                            <SelectVerified
                                value={filter_is_verified_value}
                                name="is_verified"
                                width="100%"
                                callback={onValue}
                                usersFilter
                                placeholder="Verification"
                            />
                            <input type="hidden" name="is_verified" value={filter_is_verified_value ?? ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--actions">
                            <div className="users-filter-widget__actions">
                                <a href="/cms/users" className="btn btn-cm users-filter-widget__btn">
                                    Clear
                                </a>
                                <button type="submit" className="btn btn-cm users-filter-widget__btn">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
